// @flow
import path from 'ramda/es/path';

import {
  getStateCurrentValue,
  getStateItems,
  type State,
  type PlainDatePeriodRestProps,
} from 'app/common/ui-components/filter';

import { getDisabledDaysFunc } from 'app/common/ui-next/plain-date-period';
import { dateFormat } from 'app/common/api/requests/food/schools/cafeteria_orders';


const periodProps = (state: State): PlainDatePeriodRestProps => {
  const yearCurrentIds = getStateCurrentValue('year', state);
  const years = getStateItems('year', state);
  const selectedYearId = yearCurrentIds[0];

  const dateStart = path([selectedYearId, 'date_start'], years);
  const dateFinish = path([selectedYearId, 'date_finish'], years);

  const dateDisabledStatus = getDisabledDaysFunc(dateStart, dateFinish);

  return ({
    label: 'Период времени',
    buttonResetLabel: 'Сбросить выбор',
    fromLabel: 'от',
    toLabel: 'до',
    dateFormat,
    dateDisabledStatus,
    periodLimit: 1,
    periodLimitUnit: 'months',
  });
};

export default periodProps;
